import * as types from './mutation_types'

import * as appdef from '../appdef'
import * as storage from '../utils/storage'

export default {
    [types.GET_TASKS](state, obj) {
        //console.log('mutations::GET_TASKS(): ', obj)
        state.tasks = obj.Result
    },

    [types.GET_FLOW](state, obj) {
        //console.log('mutations::GET_FLOW(): ', obj)
        state.flowList = obj.Result
    },

    [types.SUBMIT_REQUEST](state, obj) {
        //console.log('mutations::SUBMIT_REQUEST(): ', obj)
        state.agvUUID = obj.Result.split(':')[1]
    },

    [types.SAVE_FAVORITE](state, obj) {
        //console.log('mutations::SAVE_FAVORITE() ')
        state.favorites.push(obj)
        storage.save(appdef.KEY_STORAGE_FAVO, state.favorites)
    },
    [types.DELETE_FAVORITE](state, idx) {
        //console.log('mutations::DELETE_FAVORITE(): ', idx)
        state.favorites.splice(idx, 1)
        storage.save(appdef.KEY_STORAGE_FAVO, state.favorites)
        //storage.remove(appdef.KEY_STORAGE_FAVO)
    },

    [types.GET_USERLIST](state, data) {
        //console.log('mutations::GET_USERLIST: ', data)
        state.userList = data.Result
    },

    [types.PUSH_REGISTER_DEVICE](state, obj) {
        //console.log('mutations::PUSH_REGISTER_DEVICE() ')
        storage.save(appdef.KEY_STORAGE_PUSHDEVICE, true)
    },
    [types.PUSH_GET_MESSAGE](state, data) {
        //console.log('mutations::PUSH_GET_MESSAGE: ', data)
        //state.messages = data.Result
        if (data.Result != null) {
            for (var i = 0; i < data.Result.length; i++) {
                state.messages.push(data.Result[i])
            }
            storage.save(appdef.KEY_STORAGE_PUSHMESSAGE, state.messages)
        }
    },
    [types.PUSH_DELETE_MESSAGE](state, idx) {
        //console.log('mutations::PUSH_DELETE_MESSAGE(): ', idx)
        state.messages.splice(idx, 1)
        storage.save(appdef.KEY_STORAGE_PUSHMESSAGE, state.messages)
    },

    [types.SAVE_USER_INFO](state, info) {
        console.log('mutations::SAVE_USER_INFO() '+info.Identity+', '+info.Name)
        state.identity = info.Identity
        state.name = info.Name
    },

    [types.SET_LOCALE](state, locale) {
        console.log('mutations::SET_LOCALE() ')
        state.locale = locale
        this.$root.i18n.locale = locale
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js